import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component ,Input } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-heading_section-type02',
  standalone: true,
  imports: [NgIf,NgClass,NgStyle],
  templateUrl: './heading_section-type02.component.html',
  styleUrl: './heading_section-type02.component.scss'
})
export class HeadingSectionType02Component {
  @Input() options: any = {}
  
    public view: any = {

  };

  constructor( private _tfmService : TFMService) {  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      // this._tfmService.log(this.view);

    });
  }
}
